import { useEffect, useState } from "react";
import { getDestinations } from "../api";
import { useI18n, useL } from "../i18n";
import { Sparkles, ArrowRight, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function FeaturedDeals() {
  const { t, lang } = useI18n();
  const L = useL();
  const [items, setItems] = useState([]);
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  useEffect(() => {
    getDestinations({ featured: true }).then(setItems);
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10" data-testid="featured-deals">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <div className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-[#C85A32] font-semibold">
            <Sparkles className="h-3.5 w-3.5" />
            {L({ ar: "عروض الأسبوع", en: "Deals of the week", fr: "Offres de la semaine" })}
          </div>
          <h2 className="mt-2 font-display text-2xl sm:text-3xl text-[#1C1917]">
            {L({ ar: "منتقاة يدوياً لك", en: "Hand-picked for you", fr: "Sélectionnées pour vous" })}
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {items.map((d) => {
          const city = lang === "ar" ? d.city_ar : d.city_en;
          const badge = { ar: d.featured_ar, en: d.featured_en, fr: d.featured_fr }[lang] || d.featured_en;
          return (
            <Link
              to={`/destination/${d.id}`}
              key={d.id}
              className="group relative rounded-3xl overflow-hidden border border-[#E6DED3] bg-[#1C1917] aspect-[4/5] block"
              data-testid={`featured-${d.id}`}
            >
              <img src={d.image_url} alt={city} className="absolute inset-0 w-full h-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917] via-[#1C1917]/50 to-transparent" />
              <div className="absolute top-4 start-4 rounded-full bg-[#D97706] text-white text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1">
                {L({ ar: "عرض مميز", en: "Featured", fr: "Vedette" })}
              </div>
              <div className="absolute bottom-0 inset-x-0 p-5 text-[#FAF7F2]">
                <div className="text-xs uppercase tracking-widest opacity-80">{city}</div>
                <div className="mt-1 font-display text-2xl">{lang === "ar" ? d.name_ar : d.name_en}</div>
                <div className="mt-2 text-sm text-[#D97706] font-medium">{badge}</div>
                <div className="mt-3 inline-flex items-center gap-1.5 text-sm">
                  {L({ ar: "شاهد الوجهة", en: "See destination", fr: "Voir la destination" })}
                  <Arrow className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
